// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import { useId, type SelectHTMLAttributes } from 'react';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'id'> {
  label: string;
  options: readonly SelectOption[];
  error?: string;
  helperText?: string;
  placeholder?: string;
}

export function Select({
  label,
  options,
  error,
  helperText,
  placeholder,
  required,
  ...rest
}: SelectProps) {
  const id = useId();
  const helpId = `${id}-help`;
  const hasError = error !== undefined && error.length > 0;
  return (
    <div className="ds-field">
      <label htmlFor={id} className="ds-field__label">
        {label}
        {required === true ? ' *' : ''}
      </label>
      <select
        id={id}
        className="ds-field__input ds-field__select"
        data-invalid={hasError}
        aria-invalid={hasError}
        aria-describedby={hasError || helperText !== undefined ? helpId : undefined}
        required={required}
        {...rest}
      >
        {placeholder !== undefined ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} disabled={opt.disabled === true}>
            {opt.label}
          </option>
        ))}
      </select>
      {hasError ? (
        <span id={helpId} className="ds-field__error">
          {error}
        </span>
      ) : helperText !== undefined ? (
        <span id={helpId} className="ds-field__helper">
          {helperText}
        </span>
      ) : null}
    </div>
  );
}
